import { Zap } from "lucide-react";

export default function BrandHeader() {
  return (
    <header className="text-center mb-8 sm:mb-10 rise" data-testid="brand-header">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full neon-border bg-black/40 mb-5">
        <span className="relative flex w-2 h-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-[var(--neon)] opacity-60 pulse-dot" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[var(--neon)]" />
        </span>
        <span className="text-[11px] tracking-[0.22em] uppercase text-[var(--neon)] mono">
          ONLINE · PIX INSTANT
        </span>
      </div>

      <h1
        className="logo-flicker neon-text font-extrabold tracking-[0.04em] text-4xl sm:text-5xl lg:text-6xl"
        data-testid="brand-name"
      >
        MÍDIA <span className="text-white/95">STORE</span>
      </h1>

      <p className="mt-3 text-base sm:text-lg text-[var(--muted)] tracking-wider uppercase mono flex items-center justify-center gap-2">
        <Zap className="w-3.5 h-3.5 text-[var(--neon)]" />
        Sistema de Pagamentos
        <Zap className="w-3.5 h-3.5 text-[var(--neon)]" />
      </p>
    </header>
  );
}
